var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2424 19.7382C34.2424 25.7141 39.1028 30.5585 45.0983 30.5585L69.3025 30.5585L69.3025 54.6831C69.3025 60.659 74.1628 65.5034 80.1584 65.5034C86.154 65.5034 91.0144 60.659 91.0144 54.6831L91.0144 24.5472C91.0144 15.9154 83.9938 8.9179 75.3336 8.9179L45.0984 8.91789C39.1028 8.91789 34.2424 13.7623 34.2424 19.7382Z",
    fill: "#FFA1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49667 49.7531C4.49667 55.7289 9.35705 60.5734 15.3526 60.5734L39.5567 60.5734L39.5567 84.698C39.5567 90.6738 44.4171 95.5183 50.4127 95.5183C56.4083 95.5183 61.2686 90.6739 61.2686 84.698L61.2686 54.5621C61.2686 45.9303 54.2481 38.9328 45.5878 38.9328L15.3526 38.9328C9.35705 38.9328 4.49667 43.7772 4.49667 49.7531Z",
    fill: "#5E5BFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6f6c976a84ae85c73dea7706fea4a269.svg";
export { ForwardRef as ReactComponent };